import { UTA_FORM_TA_FIELD_ENUM } from '@components-member/TradingAccounts/AccountCreate/enums';
import { IContext } from '@components-member/TradingAccounts/AccountCreate/interfaces';
import {
  COPYTYPE_FIELD,
  IBCODE_FIELD,
  LEVERAGE_FIELD,
} from '@components-member/TradingAccounts/AccountCreate/sharedFields';
import {
  DEPOSIT_AMOUNT,
  MAKE_MIN_DEPOSIT_AMOUNT_REQUIRED,
  PROFIT_SHARING_FIELD,
  TYPE_FIELD,
} from '@components-member/shared/forms/formFields';
import { IModalFormField } from '@components-member/socialTrading/social.interfaces';
import { keyMap } from '@locales/lokalise/keyMap';
import generator from 'components/shared/forms/formGenerator';

export const MASTER_ACCOUNT_FIELDS: IModalFormField[] = [
  {
    ...TYPE_FIELD,
    name: UTA_FORM_TA_FIELD_ENUM.type,
    title: keyMap.sharedFieldsAccountType,
    attributes: { autoComplete: 'off' },
    required: true,
    className: 'lg-4 md-4',
  },
  {
    ...COPYTYPE_FIELD,
    options: [],
    attributes: { autoComplete: 'off', disabled: true },
    required: true,
    className: 'lg-4 md-4',
  },
  {
    ...LEVERAGE_FIELD,
    attributes: { autoComplete: 'off' },
    className: 'lg-4 md-4',
  },
  {
    name: UTA_FORM_TA_FIELD_ENUM.commissionAccountId,
    title: keyMap.copyTradingCommissionAccount,
    type: 'customSelect',
    options: [],
    attributes: { autoComplete: 'off' },
    className: 'lg-4 md-4',
    required: true,
  },
  {
    ...IBCODE_FIELD,
    className: 'lg-4 md-4',
  },
  {
    ...DEPOSIT_AMOUNT,
    name: UTA_FORM_TA_FIELD_ENUM.recommendedMinDepositAmount,
    className: 'lg-4 md-4',
  },
  {
    ...MAKE_MIN_DEPOSIT_AMOUNT_REQUIRED,
    className: 'lg-4 md-4',
  },
  {
    ...PROFIT_SHARING_FIELD,
    name: UTA_FORM_TA_FIELD_ENUM.profitSharing,
    className: 'lg-4 md-4',
  },
  {
    name: UTA_FORM_TA_FIELD_ENUM.isVisible,
    type: 'checkbox',
    title: keyMap.copyTradingIsVisible,
    attributes: { autoComplete: 'off' },
    labelClassName: 'custom-style',
    className: 'custom-margin full-width',
  },
];

export const MasterAccountForm = generator(MASTER_ACCOUNT_FIELDS, {
  type: (ctx: IContext, value: number) => {
    const { typeTrigger } = ctx.props;

    if (typeTrigger) {
      typeTrigger(value);
    }
  },
  makeMinDepositAmountRequired: (ctx: IContext, value: boolean) => {
    const { makeDepositReqTrigger } = ctx.props;

    if (makeDepositReqTrigger) {
      makeDepositReqTrigger(value);
    }
  },
});
